class UserIdStore {
  private static instance: UserIdStore;
  private userId: string = "";

  private constructor() {
    const storedUserId = localStorage.getItem("user_id");
    if (storedUserId) {
      this.userId = storedUserId;
    }
  }

  public static getInstance(): UserIdStore {
    if (!UserIdStore.instance) {
      UserIdStore.instance = new UserIdStore();
    }
    return UserIdStore.instance;
  }

  public setUserId(userId: string) {
    this.userId = userId;
    localStorage.setItem("user_id", userId);
  }

  public getUserId(): string | null {
    return this.userId || localStorage.getItem("user_id");
  }

  public clearUserId() {
    this.userId = "";
    localStorage.removeItem("user_id");
  }
}

export default UserIdStore.getInstance();
